import React from 'react';
import './ScrollIndicator.css';

const ScrollIndicator = ({ targetId }) => {
  const handleClick = () => {
    if (targetId) {
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // Default behavior: scroll down by 100vh
      window.scrollTo({
        top: window.innerHeight,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="scroll-indicator-container" onClick={handleClick}>
      <div className="mouse">
        <div className="wheel"></div>
      </div>
    </div>
  );
};

export default ScrollIndicator;
